import AppNavigator from './route'

function App() {
  return (
    <div>
      <AppNavigator />
    </div>
  );
}

export default App;